import { z } from 'zod'

export const GetMarketMakerProjectResult = z.object({
  id: z.string().uuid(),
  name: z.string(),
  acceptedContactMarketMakers: z.boolean().nullable(),
  isMarketMakerMonitoringEnabled: z.boolean(),
  acceptedTerms: z.boolean().nullable(),
  otherMarketMakers: z.array(z.string()).nullable(),
  marketMakerIds: z.array(z.string()),
  projectCalendly: z.string().nullable(),
  projectEmail: z.string().nullable(),
  projectTelegram: z.string().nullable(),
  projectUrl: z.string().nullable(),
})
export type GetMarketMakerProjectResultType = z.infer<typeof GetMarketMakerProjectResult>

export const BasePostMarketMakerProjectSchema = z.object({
  acceptedContactMarketMakers: z.boolean().refine((value) => value === true, 'Required'),
  acceptedTerms: z.boolean().refine((value) => value === true, 'Required'),
  otherMarketMakers: z.array(z.string().trim()).nullable(),
  projectCalendly: z
    .union([z.string().trim().url(), z.literal(''), z.null()])
    .transform((value) => (value ? value : null)),
  projectEmail: z.string().email().nullable(),
  projectTelegram: z.string().nullable(),
})

export const EngageMarketMakerSchema = BasePostMarketMakerProjectSchema.extend({
  marketMakerIds: z.array(z.string()),
}).superRefine((data, ctx) => {
  if (!data.projectEmail && !data.projectTelegram) {
    const message = 'Either email or telegram must be provided.'
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['projectEmail'],
      message,
    })
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['projectTelegram'],
      message,
    })
  }
})

export type EngageMarketMakerType = z.infer<typeof EngageMarketMakerSchema>
